import React from 'react';
import List from '../components/List';
import gql from 'graphql-tag';
import useQuery from '../../../../../modules/react/hooks/useQuery';
import useMutation from '../../../../../modules/react/hooks/useMutation';

const GET_BLOG_DATA = gql`
  query GetBlogListPostData($sortParameters: BlogPostsSortInput) {
    blogPosts(sortParameters: $sortParameters) {
      edges {
        node {
          id
          ...BlogPostData
        }
      }
    }
  }

  ${List.fragments.posts}
`;

const getBlogListPostDataVars = {
  variables: {
    sortParameters: {
      sortBy: 'date',
      sortDirection: -1,
    },
  },
};

export const GET_BLOG_DATA_QUERY = {
  query: GET_BLOG_DATA,
  ...getBlogListPostDataVars,
};

const DELETE_BLOG_POST = gql`
  mutation DeleteBlogPost($id: ID!) {
    blogPostDelete(id: $id) {
      post
      userErrors {
        code
        message
      }
    }
  }
`;

const ListContainer = () => {
  const { data, loading: blogDataLoading } = useQuery(
    GET_BLOG_DATA,
    getBlogListPostDataVars,
  );

  const [deleteBlogPost] = useMutation(DELETE_BLOG_POST, { refetchQueries: ['GetBlogListPostData'] });

  const posts = data?.blogPosts?.edges.map(({ node }) => node) || [];

  return <List
    isLoading={blogDataLoading}
    posts={posts}
    onDelete={deleteBlogPost}
  />;
};

export default ListContainer;
